import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { view } from '@yola/ws-sdk';
import { PANEL_WIDTH_CSS_VAR } from 'src/js/modules/view/constants/common';

// Publishes how much of the window the docked panel occupies, in the two forms
// the editor reads it: a CSS custom property for stylesheets, and a viewport
// inset in the store for JS.
const usePanelWidth = (panelWidth) => {
  const dispatch = useDispatch();
  const prevPanelWidth = useRef(panelWidth);

  useEffect(() => {
    document.body.style.setProperty(PANEL_WIDTH_CSS_VAR, `${panelWidth}px`);
    dispatch(view.actions.setViewportInsets({ right: panelWidth }));

    return () => {
      document.body.style.setProperty(PANEL_WIDTH_CSS_VAR, '0px');
      dispatch(view.actions.setViewportInsets({ right: 0 }));
    };
  }, [dispatch, panelWidth]);

  useEffect(() => {
    if (prevPanelWidth.current === panelWidth) return;

    dispatch(view.actions.setHoveredElement(null));
    dispatch(view.actions.setFocusedElement(null));
    dispatch(view.actions.setSelectedElement(null));

    prevPanelWidth.current = panelWidth;
  }, [dispatch, panelWidth]);
};

export default usePanelWidth;
